<template>
  <el-dialog
    :title='title'
    :visible.sync='visible'
    width='600px'
    center
    :close-on-click-modal='false'
    @close='closeDialog'>
    <el-form :model='form' label-width='120px' :rules='rules' ref='ruleForm'
             size='medium'>
      <el-form-item label='船舶名称：' prop='shipName'>
        <el-input v-model='form.shipName' placeholder='请输入船舶名称' />
      </el-form-item>
      <el-form-item label='航次编号：' prop='voyageNumber'>
        <el-input v-model='form.voyageNumber' placeholder='请输入航次编号' />
      </el-form-item>
      <el-form-item label='开放港口：' v-if="title == '开放航次'">
        <el-input v-model='form.portName' placeholder='请输入开放港口' />
      </el-form-item>
      <div class='btnContainer'>
        <el-button size='medium' class='searchBtn' @click='submit'>
          确定
        </el-button>
        <el-button size='medium' class='resetBtn' @click='closeDialog'>关闭</el-button>
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
  import divBorder from '@/components/divBorder.vue';
  import { DevOpsVoyage, closeVoyage } from '@/service/DevOps';

  export default {
    name: 'index',
    components: { divBorder },
    data() {
      return {
        title: '',
        visible: false,
        form: {
          shipName: '',
          voyageNumber: '',
        },
        rules: {
          shipName: [
            {
              required: true,
              message: '请输入船舶名称',
              trigger: 'change',
            },
          ],
          voyageNumber: [
            {
              required: true,
              message: '请输入航次编号',
              trigger: 'change',
            },
          ],
        },
      };
    },
    methods: {
      submit() {
        this.$refs.ruleForm.validate(async (valid) => {
          if (valid) {
            if (this.title == '开放航次') {
              const {
                status,
                message,
              } = await DevOpsVoyage(this.form);
              if (status !== 0) return this.$message.warning(message);
              this.$message.success(message);
            } else {
              const {
                status,
                message,
              } = await closeVoyage(this.form);
              if (status !== 0) return this.$message.warning(message);
              this.$message.success(message);
            }
            
            this.closeDialog();
          }
        });
      },
      openDialog(title) {
        this.title = title;
        this.visible = true;
      },
      closeDialog() {
        this.visible = false;
        this.$refs.ruleForm.resetFields();
      },
    },
  };
</script>

<style lang='scss' scoped>
  .el-form-item {
    margin-top: 18px;
  }

  .btnContainer {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 30px 0 10px 0;

    button {
      margin: 0 15px;
    }
  }
</style>
